import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
export function createAudit(_ref, payload) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit,
    getters = _ref.getters;
  return dispatch('api', {
    url: 'audits',
    method: 'post',
    data: payload
  }, {
    root: true
  });
}
export function getAudits(_ref2, payload) {
  var dispatch = _ref2.dispatch,
    commit = _ref2.commit,
    getters = _ref2.getters;
  commit('SET_AUDIT_PARAMS', payload.params);
  return dispatch('api', {
    url: 'audits',
    params: getters.auditParams
  }, {
    root: true
  }).then(function (response) {
    commit('SET_ARRAY', {
      state: 'audits',
      data: response.data.data
    });
    commit('SET_DATA', {
      state: 'auditsMeta',
      data: response.data.meta
    });
    return response.data;
  });
}
export function openAuditCommentEntry(_ref3, auditId) {
  var dispatch = _ref3.dispatch,
    commit = _ref3.commit;
  dispatch('getEntry', auditId);
  commit('auditPanel/SET_OPEN', true, {
    root: true
  });
}
export function getEntry(_ref4, auditId) {
  var dispatch = _ref4.dispatch,
    commit = _ref4.commit,
    getters = _ref4.getters;
  return dispatch('api', {
    url: 'audits/' + auditId,
    wait: 'get-entry'
  }, {
    root: true
  }).then(function (response) {
    window.location.hash = 'audit/' + auditId;
    commit('SET_ENTRY', response.data);
    var auditCommentIds = getters.unseens.filter(function (u) {
      return u.id === auditId;
    }).map(function (u) {
      return u.audit_comment_id;
    }).join();
    if (auditCommentIds) {
      dispatch('setSeen', {
        auditCommentIds: auditCommentIds
      });
    }
  });
}

/**
 * Get latest paginated comments.
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param payload
 * @returns {*}
 */
export function getAuditComments(_ref5, payload) {
  var dispatch = _ref5.dispatch,
    commit = _ref5.commit,
    getters = _ref5.getters;
  return dispatch('api', {
    url: 'audits/' + payload.auditId + '/comments',
    params: {
      lastId: payload.lastId || null,
      page: payload.page || 1,
      limit: payload.limit || 10,
      orderBy: payload.orderBy || 'created_at',
      descending: payload.descending || 1
    }
  }, {
    root: true
  }).then(function (response) {
    commit('SET_COMMENTS', response.data);
  });
}

/**
 * Get a comment children.
 *
 * @param dispatch
 * @param commit
 * @param payload
 * @returns {*}
 */
export function getCommentChildren(_ref6, payload) {
  var dispatch = _ref6.dispatch,
    commit = _ref6.commit;
  return dispatch('api', {
    url: 'audits/comment/' + payload.commentId + '/children',
    params: {
      lastId: payload.lastId || null,
      page: payload.page || 1,
      limit: payload.limit || 5,
      orderBy: payload.orderBy || 'created_at',
      descending: payload.descending || 1
    }
  }, {
    root: true
  }).then(function (response) {
    commit('SET_COMMENT_CHILDREN', {
      commentId: payload.commentId,
      data: response.data.data,
      meta: response.data.meta
    });
    return Promise.resolve(response.data);
  });
}

/**
 * Get Audit Comment for given ID and update the entry state.
 *
 * @param dispatch
 * @param commit
 * @param commentId
 * @returns {*}
 */
export function getAuditComment(_ref7, commentId) {
  var dispatch = _ref7.dispatch,
    commit = _ref7.commit;
  return dispatch('api', {
    url: 'audits/comment/' + commentId,
    wait: 'get-comment'
  }, {
    root: true
  }).then(function (response) {
    commit('UPDATE_COMMENT', response.data.data);
  });
}
export function dismissEntry(_ref8) {
  var commit = _ref8.commit;
  commit('SET_ENTRY', {});
  commit('SET_DATA', {
    state: 'comments',
    data: []
  });
  commit('SET_DATA', {
    state: 'commentsMeta',
    data: {}
  });
  commit('SET_DATA', {
    state: 'commentsChildren',
    data: {}
  });
  commit('SET_DATA', {
    state: 'commentsChildrenMeta',
    data: {}
  });
}

/**
 * Reply to a comment.
 *
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {number} payload.auditId
 * @param {number} payload.parentId
 * @param {string} payload.comment
 * @param {string} payload.flag
 * @param {number} payload.autoResponse
 * @returns {*}
 */
export function reply(_ref9, payload) {
  var dispatch = _ref9.dispatch,
    commit = _ref9.commit;
  return dispatch('api', {
    url: 'audits/' + payload.auditId + '/reply',
    method: 'post',
    data: {
      parent_id: payload.parentId,
      comment: payload.comment,
      flag: payload.flag,
      auto_response: payload.autoResponse
    }
  }, {
    root: true
  }).then(function (response) {
    if (response.data.data.parent_id) {
      commit('APPEND_COMMENT_CHILDREN', response.data.data);
    } else {
      commit('APPEND_COMMENT', response.data.data);
    }
  });
}

/**
 * Update text of a comment.
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id - Comment ID
 * @param {Object} payload.data
 * @param {string} payload.data.comment - Comment text
 * @param {string} payload.data.flag
 * @returns {*}
 */
export function updateComment(_ref10, payload) {
  var dispatch = _ref10.dispatch,
    commit = _ref10.commit;
  return dispatch('api', {
    url: 'audits/comment/' + payload.id,
    method: 'put',
    data: payload.data
  }, {
    root: true
  }).then(function (response) {
    if (response.data.data.parent_id) {
      commit('UPDATE_COMMENT_CHILDREN', response.data.data);
    } else {
      commit('UPDATE_COMMENT', response.data.data);
    }
  });
}

/**
 * Delete a comment.
 * @param dispatch
 * @param commit
 * @param {Object} payload
 * @param {number} payload.id
 * @param {number} payload.parent_id
 * @returns {*}
 */
export function deleteComment(_ref11, payload) {
  var dispatch = _ref11.dispatch,
    commit = _ref11.commit;
  var commentId = payload.id;
  return dispatch('api', {
    url: 'audits/comment/' + commentId,
    method: 'delete'
  }, {
    root: true
  }).then(function () {
    if (payload.parent_id) {
      commit('DELETE_COMMENT_CHILD', {
        id: payload.id,
        parentId: payload.parent_id
      });
    } else {
      commit('REMOVE_FROM_ARRAY', {
        state: 'comments',
        key: 'id',
        data: {
          id: commentId
        }
      });
    }
  });
}
export function getUnseens(_ref12) {
  var dispatch = _ref12.dispatch,
    commit = _ref12.commit,
    rootGetters = _ref12.rootGetters;
  // Do not run it in maintenance mode...
  if (rootGetters['common/check'].maintenanceMode !== 'yes') {
    return dispatch('api', {
      url: 'audits/unseen'
    }, {
      root: true
    }).then(function (response) {
      if (response !== null && response !== void 0 && response.data) {
        commit('SET_ARRAY', {
          state: 'unseens',
          data: response.data.data
        });
      }
    });
  }
}
export function setSeen(_ref13, payload) {
  var dispatch = _ref13.dispatch,
    commit = _ref13.commit;
  return dispatch('api', {
    method: 'post',
    url: 'audits/seen',
    data: {
      audit_comment_ids: payload.auditCommentIds
    }
  }, {
    root: true
  }).then(function (response) {
    commit('UPDATE_UNSEENS', response.data);
  });
}
export function resolveAction(_ref14, payload) {
  var dispatch = _ref14.dispatch,
    commit = _ref14.commit;
  return dispatch('conceptActions/resolveAction', {
    id: payload.id,
    approve: payload.approve,
    deleteRelated: payload.deleteRelated
  }, {
    root: true
  }).then(function (response) {
    commit('UPDATE_CONCEPT_ACTION_ON_AUDIT', response.data.data);
  });
}
export function getDetachedQueries(_ref15, payload) {
  var dispatch = _ref15.dispatch;
  return dispatch('api', {
    url: 'concept-actions/details/' + payload.id + '/detached-queries',
    params: payload.params
  }, {
    root: true
  });
}
export function updateAudit(_ref16, payload) {
  var dispatch = _ref16.dispatch;
  return dispatch('api', {
    method: 'put',
    url: 'audits/' + payload.id,
    data: payload.data
  }, {
    root: true
  });
}
export function onClose(_ref17) {
  var getters = _ref17.getters,
    commit = _ref17.commit;
  var unseens = getters.unseens;
  this.reset({
    self: false,
    nested: false,
    modules: {
      audits: {
        self: true,
        nested: true
      }
    }
  });

  // Restore unseens data
  commit('SET_DATA', {
    state: 'unseens',
    data: unseens
  });
}